import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatSidenav } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { Router, ActivatedRoute } from '@angular/router'
import { ToastService } from 'ng-uikit-pro-standard';

import { GUID } from '../../guid'
import { DataService } from './../../data.service';
import { AppConfig } from './../../config';

//import { template } from '@angular/core/src/render3';

@Component({
  selector: 'app-metalayoutquick',
  templateUrl: './metalayoutquick.component.html',
  styleUrls: ['./metalayoutquick.component.scss']
})
export class MetaLayoutQuickComponent implements OnInit {
  @ViewChild(MatSidenav, { static: false }) set mscontent(ms: MatSidenav) {
    this.rightSideNav = ms;
  }

  isDataLoaded = true;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metaobjectId = "";
  metaobjectName = "";
  metalayoutId = "";
  metalayoutName = "";
  displayName = "";
  action = "";
  mode = "New";
  metalayout:any;
  guid: GUID;

  profiles = [];
  recordTypes = [];

  buttonList = [];
  selectedButtons = [];
  selectedButton = "";
  unSelectedButtons = [];

  fields = [];
  fieldList = [];
  systemFields = ['createddate', 'createdby', 'createdbyalias', 'createdbyid', 'modifieddate', 'modifiedby', 'modifiedbyalias', 'modifiedbyid'];
  groupList = [];
  column1GroupFields = {};

  fieldTypeSelect = [];
  fieldOption: any;

  setDefaultOption() {
    this.fieldOption = {
      column: 1,
      groupid: "",
      groupname: "",
      fieldid: "",
      fieldname: "",
      required: false,
      readonly: false
    }
  }


  detailForm = this.fb.group({
    fieldtype: '',
  });

  buttonForm = this.fb.group({
    buttoncount: 0,
  });

  groupForm = this.fb.group({
    groupcount: 0,
  });

  sideNavoptions: FormGroup;
  showTempGroup: boolean = false;
  rightSideNav: MatSidenav;

  layoutData = {}
  tempGroup = {
    groupid: "none",
    groupname: "",
    showondetailpage: true,
    showoneditpage: true,
    fields: [],
    attributes: {},
    attributesArray: []
  }

  setDefaultTempGroup() {
    this.tempGroup = {
      groupid: "none",
      groupname: "",
      showondetailpage: true,
      showoneditpage: true,
      fields: [],
      attributes: {},
      attributesArray: []
    }

    this.oldTempGroup = {
      groupid: "none",
      groupname: "",
      showondetailpage: true,
      showoneditpage: true,
      fields: [],
      attributes: {},
      attributesArray: []
    }
  }


  onSelect(event: TypeaheadMatch, objectName: string): void {
    if (objectName == 'button') {
      this.selectedButton = ""
      this.selectedButtons.push(event.item)
      this.unSelectedButtons = this.unSelectedButtons.filter(eachUnselected => eachUnselected != event.item)
    }
  }

  removeSelectedItem(selectedItem: any, objectName: string) {
    if (objectName == 'button') {
      this.unSelectedButtons.push(selectedItem)
      this.selectedButtons = this.selectedButtons.filter(eachUnselected => eachUnselected != selectedItem)
    }
  }

  dropButton(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedButtons, event.previousIndex, event.currentIndex);
  }

  dropGroup(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.groupList, event.previousIndex, event.currentIndex);
  }

  drop(event: CdkDragDrop<string[]>, groupName: string | number, column: any) {
    console.log("groupName", groupName);
    console.log("column", column);
    console.log("event.previousContainer.data", event.previousContainer.data);
    console.log("event.container.data", event.container.data)

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    console.log("event.currentIndex", event.currentIndex);

    //reset slno for column1GroupFields, column2GroupFields, column3GroupFields
    for (let i = 0; i < this.column1GroupFields[groupName].length; i++) {
      this.column1GroupFields[groupName][i]['slno'] = i + 1 + '_C1';
    }

    console.log("this.column1GroupFields", this.column1GroupFields);

  }

  showSuccess(data: any) {
    let options = { enableHtml: true, positionClass: 'md-toast-top-right', timeOut: 3000 };
    this.toastrService.success(data, '', options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: 'md-toast-bottom-right' };
    this.toastrService.error(data, 'Application Error!', options);
  }

  showWarning(data: any) {
    let options = { enableHtml: true, positionClass: 'md-toast-bottom-right', messageClass: 'orange darken-4', toastClass: 'warning-color-dark' };
    this.toastrService.warning(data, '', options);
  }

  metaobjectDetail() {
    this.router.navigateByUrl('home/metaobjectdetail/' + this.metaobjectId + "/" + this.metaobjectName);
  }
  metaobjectPageLayouts() {
    this.router.navigateByUrl('home/metaobjectdetail/' + this.metaobjectId + "/" + this.metaobjectName + "#layouts");
  }
  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private appConfig: AppConfig,
    private dataService: DataService, private toastrService: ToastService, public dialog: MatDialog) {
    this.sideNavoptions = fb.group({
      bottom: 0,
      fixed: true,
      top: 55
    });

  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      if (this.mode.toLowerCase().trim() == 'edit') {
        this.metalayoutId = this.route.snapshot.params.id;
        this.metalayoutName = this.route.snapshot.params.metalayoutname;
        this.displayName = this.route.snapshot.params.displayname;
        this.action = this.route.snapshot.params.action;
      }
    });

    this.guid = new GUID();

    //this.unSelectedButtons = JSON.parse(JSON.stringify(this.buttonList))
    this.setDefaultOption();


    //create field type picklist from fieldtypes
    for (let i = 0; i < this.appConfig.fieldTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.fieldTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.fieldTypeSelect.push({
        value: this.appConfig.fieldTypes[i],
        label: strLabel,
      });

    }

    //load profiles 
    this.getActiveProfiles().then(res => {
      console.log("profiles", this.profiles);
    });

    //load recordtypes
    this.getRecordTypes().then(res => {
      console.log("recordtypes", this.recordTypes);
    }); //getRecordTypes()

    this.getMetaButtonsForSelection().then(res => {
      console.log("response1111", res);
      this.unSelectedButtons = JSON.parse(JSON.stringify(this.buttonList));

      this.getMetaFieldsForSelection().then(res => {
        console.log("response2222", res);

        // load metalayout details
        this.getMetaLayoutByName().then(res => {

          //assign metalayout detail data
          this.assignMetalayoutData();

          console.log("this.column1GroupFields", this.column1GroupFields);

        }); //getMetaLayoutByName 


      });//getMetaFieldsForSelection

    }); // getMetaButtonsForSelection


  }

  close(reason: string) {
    //alert('called')
    // this.reason = reason;
    // this.rightSideNav.open();
  }

  formAction(buttonName: any, group: any, relatedList: any, id: any) {
    //alert(buttonName)

    switch (buttonName) {
      case 'cancel': {
        //this._router.navigateByUrl('/admin/viewobject/' + id)
        break
      }
      case 'addGroup': {
        this.action = "new"
        this.addGroup(group)
        break
      }
      case 'getGroup': {
        this.getGroup(group)
        break
      }
      case 'cancelupdategroup': {
        this.cancelUpdateGroup()
        break
      }
      // case 'editGroup': {
      //   this.editGroup(groupid)
      //   break
      // }
      case 'deleteGroup': {
        this.deleteGroup(group)
        break
      }
      case 'changeShowTempGroup': {
        this.changeShowTempGroup()
        break
      }
      case 'addEmptyPropery': {
        //this.addEmptyProperyInTempGroup()
        break
      }
      case 'deleteTempGroupPropery': {
        //this.deleteTempGroupPropery(group)
        break
      }
      case 'unSelectRelatedList': {
        //this.unSelectRelatedList(relatedList)
        break
      }
      case 'getRelatedList': {
        //alert(JSON.stringify(relatedList))
        //this.getRelatedList(relatedList)
        break;
      }
      // case 'updateRelatedList': {
      //   this.updateRelatedList()
      //   break;
      // }
      case 'setMedataData': {
        //this.setMetaData()
        break
      }
      case 'savePageLayout': {
        //this.savePageLayout()
        break
      }
    }

  }

  setMetaData() {

  }

  oldTempGroup = {
    groupid: "none",
    groupname: "",
    showondetailpage: true,
    showoneditpage: true,
    fields: [],
    attributes: {},
    attributesArray: []
  }
  getGroup(group: { groupid: any; }) {
    //alert('get group called')
    // //alert(JSON.stringify(group))

    // this.tempGroup = this.layoutData['layoutjsontext']['groups'].filter(obj => obj.groupid == group.groupid)[0]

    this.tempGroup = this.groupList.filter(eachGroup => eachGroup.groupid == group.groupid)[0]
    if (this.tempGroup.groupname == this.metaobjectName + ' ' + 'Information') {
      this.tempGroup['disablenamefield'] = true;
    }
    else {
      this.tempGroup['disablenamefield'] = false;
    }

    // console.log(JSON.stringify(this.tempGroup))
    // //alert(JSON.stringify(this.tempGroup))
    // //alert(JSON.stringify(Object.keys(this.tempGroup.attributes))+' updated')
    // this.tempGroup['attributesArray']=[]
    // if(this.tempGroup.attributes!={})
    // {
    Object.keys(this.tempGroup.attributes).forEach(eachAttributeKey => {
      this.tempGroup['attributesArray'].push({
        key: eachAttributeKey, value: this.tempGroup.attributes[eachAttributeKey]
      })
    })
    // }
    // else{

    // }
    // this.oldTempGroup = Object.assign({}, this.tempGroup)
    this.oldTempGroup = JSON.parse(JSON.stringify(this.tempGroup))
    this.changeShowTempGroup()
  }
  cancelUpdateGroup() {
    if (this.oldTempGroup.groupid == 'none') {
      // this.groupList.push(Object.assign({}, this.oldTempGroup))
      // this.column1GroupFields[this.oldTempGroup.groupname] = []
      this.setDefaultTempGroup()
    }
    else {
      //alert(JSON.stringify(this.oldTempGroup))
      // this.groupList.forEach((obj, index, array) => {
      //   if (obj.groupid == this.oldTempGroup.groupid) {
      //     this.updateGroup(index, true)
      //   }
      // })
    }
    this.rightSideNav.close()
    this.setDefaultTempGroup()
  }


  addGroup(group: any) {
    //alert(group)

    if (this.tempGroup.groupid == 'none') {
      this.tempGroup.groupid = this.guid.getGUID('MetaLayoutGroup')
      // this.layoutData['layoutjsontext']['groups'].push(Object.assign({}, this.tempGroup))
      // this.groupList.push({ groupid: this.tempGroup.groupid, groupname: this.tempGroup.groupname })
      this.groupList.push(Object.assign({}, this.tempGroup))
      this.column1GroupFields[this.tempGroup.groupname] = []
      this.setDefaultTempGroup()
    }
    else {
      // this.tempGroup = this.layoutData['layoutjsontext']['groups'].filter(obj => obj.groupid == groupid)
      // let index = this.layoutData['layoutjsontext']['groups'].indexOf(this.tempGroup)
      // this.layoutData['layoutjsontext']['groups'].forEach((obj, index, array) => {
      this.groupList.forEach((obj, index, array) => {
        if (obj.groupid == this.tempGroup.groupid) {
          this.updateGroup(index, false)
        }
      })
    }
    this.rightSideNav.close()
    console.log('after create');
    console.log(this.groupList);

  }

  updateGroup(index: number, isCancel: boolean) {
    if (!isCancel) {
      Object.keys(this.tempGroup).forEach(eachKey => {
        // this.layoutData['layoutjsontext']['groups'][index][eachKey] = this.tempGroup[eachKey]
        this.groupList[index][eachKey] = this.tempGroup[eachKey]
      })
      this.column1GroupFields[this.tempGroup.groupname] = []
      this.column1GroupFields[this.tempGroup.groupname] = this.column1GroupFields[this.oldTempGroup.groupname]
      delete this.column1GroupFields[this.oldTempGroup.groupname]
    } else {
      Object.keys(this.oldTempGroup).forEach(eachKey => {
        // this.layoutData['layoutjsontext']['groups'][index][eachKey] = this.tempGroup[eachKey]
        this.groupList[index][eachKey] = this.oldTempGroup[eachKey]
      })
      this.column1GroupFields[this.oldTempGroup.groupname] = []
      this.column1GroupFields[this.oldTempGroup.groupname] = this.column1GroupFields[this.oldTempGroup.groupname]
      delete this.column1GroupFields[this.oldTempGroup.groupname]
    }
    this.setDefaultTempGroup()
  }

  changeShowTempGroup() {
    // this.showTempGroup=!this.showTempGroup
    this.rightSideNav.open()
  }

  deleteGroup(deleteGroup: { groupname: string; groupid: any; }) {

    //Cannot delete detail group / section    
    if (deleteGroup.groupname == this.metaobjectName + ' ' + 'Information') {
      alert("Information group cannot be deleted!");
      return;
    }
    //this.fieldList.push(...this.column1GroupFields[deleteGroup.groupname]);
    delete this.column1GroupFields[deleteGroup.groupname];
    this.groupList = this.groupList.filter(eachGroup => eachGroup.groupid != deleteGroup.groupid)
    console.log('after delete')
    console.log(this.groupList);
    console.log('.....')

    this.setDefaultTempGroup()
  }

  getActiveProfiles() {
    return new Promise((resolve, reject) => {

      console.log("getActiveProfiles");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          profile: {
            userlicense: localStorage.getItem("crm_userlicense")
          }
        }
      }
      console.log("postOption", postOption)
      this.isLoading = true;
      this.dataService.getActiveProfileByUserLicense(postOption).subscribe(
        res => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.profiles = res.data.profiles;
            this.isLoading = false;
            resolve(null);
          }
          else {
            console.log("No profile data!");
            this.errorMessage = (res != null ? res.message : "No profile data!");
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        err => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }

      );

    });
  }

  getRecordTypes() {
    return new Promise((resolve, reject) => {

      console.log("getRecordTypes");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          recordtype: {
            metaobjectid: this.metaobjectId
          }
        }
      }

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getRecordTypes(postOption).subscribe(
        res => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.recordTypes = res.data.recordtypes;

            this.isLoading = false;
            resolve(null);
          }
          else {
            console.log("error");
            this.isLoading = false;
            resolve(null);
          }
        },
        err => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }

      );

    });
  }


  getMetaButtonsForSelection() {
    return new Promise((resolve, reject) => {

      console.log("getMetaButtonsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        profileid: userDetail.profileid,
        data: {
          metabutton: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
            actiontype: this.action,
          }
        }
      }

      console.log("postOption", postOption);

      this.isLoading = true;
      /*
      this.dataService.getMetaButtonsForSelection(postOption).subscribe(
        res => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.buttonList = res.data.metabuttons;
            console.log("buttonList", this.buttonList);
            //console.log("buttonList1", this.buttonList1);

            this.isLoading = false;
            resolve();
          }
          else {
            console.log("error");
            this.isLoading = false;
            resolve();
          }
        },
        err => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve();
        }

      );*/

    });
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {

      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName
          }
        }
      }

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        res => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == 'id') continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip system or audit fields etc.,
              if (this.systemFields.includes(field.fieldname.toLowerCase())) continue;

              //skip fields deleted, ownertype etc.,
              if (field.fieldname.toLowerCase() == 'deleted' || field.fieldname.toLowerCase() == 'ownertype' ||
                field.fieldname.toLowerCase() == 'ownername') continue;

              //skip read, name, converted, etc., fields if object is lead
              if (this.metaobjectName.toLowerCase().trim() == "lead" &&
                (field.fieldname.toLowerCase() == 'read' || field.fieldname.toLowerCase() == 'name' || field.fieldname.toLowerCase() == 'converted' ||
                  field.fieldname.toLowerCase() == 'createdmonth' || field.fieldname.toLowerCase() == 'emailbounceddate' ||
                  field.fieldname.toLowerCase() == 'emailbouncedreason' || field.fieldname.toLowerCase() == 'lastactivity' ||
                  field.fieldname.toLowerCase() == 'lasttransferdate')) continue;

              //convert to titecase
              var strLabel = field.labelname;
              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);

              this.fieldList.push({
                fieldname: field.fieldname,
                labelname: strLabel,
                fieldtype: field.fieldtype,
                standard: field.standard,
                required: field.required,
                readonly: field.readonly,
                options: field.options,
                id: field.id,
              });
            }


            this.isLoading = false;
            resolve(null);
          }
          else {
            console.log("error");
            this.isLoading = false;
            resolve(null);
          }
        },
        err => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }

      );

    });
  }

  getMetaLayoutByName() {
    return new Promise((resolve, reject) => {

      console.log("getMetaLayoutByName");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          metalayout: {
            name: this.metalayoutName
          }
        }
      }

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetalayoutByName(postOption).subscribe(
        res => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metalayout = res.data.metalayout;
            this.isLoading = false;
            resolve(null);
          }
          else {
            console.log("error");
            this.isLoading = false;
            resolve(null);
          }
        },
        err => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }

      );

    });
  }

  assignMetalayoutData() {
    if (this.metalayout != null) {

      //load selected buttons
      var metaLayoutButtons = this.metalayout.metalayoutbuttons;
      if (metaLayoutButtons.length > 0) {
        this.selectedButton = ""
        //add selected buttons array
        for (let btn of metaLayoutButtons) {
          this.selectedButtons.push(btn);
        }

        //remove selected buttons from unselected buttons
        for (let btn of this.selectedButtons) {
          this.unSelectedButtons = this.unSelectedButtons.filter(eachUnselected => eachUnselected.name != btn.name);
        }

      }


      //load groups
      var groups = this.metalayout.metalayoutgroups;
      for (let group of groups) {
        var grp = {
          groupid: group.id,
          groupname: group.name,
          showondetailpage: group.showondetailpage,
          showoneditpage: group.showoneditpage,
          fields: [],
          attributes: {},
          attributesArray: []
        }

        this.column1GroupFields[group.name] = [];
        this.groupList.push(grp);
      }

      //reverse the array
      this.groupList.reverse();

      this.setDefaultTempGroup();

      //load groupfields 
      var groupFields = this.metalayout.metalayoutgroupfields;
      var index = 1;
      for (let i = 0; i < groupFields.length; i++) {
        var field = groupFields[i];
        var groupFieldAttributes = field.attributes;

        //skip id type fields if there
        if (field.fieldtype.toLowerCase() == 'id') continue;
        //skip ownername, ownertype fields if action is new
        if (this.metalayout.action.toLowerCase().trim() == 'new') {
          if (field.fieldname.toLowerCase() == 'ownername') continue;
          if (field.fieldname.toLowerCase() == 'ownertype') continue;
        }
        else if (this.metalayout.action.toLowerCase().trim() == 'view') {
          if (field.fieldname.toLowerCase() == 'ownertype') continue;
        }
        else if (this.metalayout.action.toLowerCase().trim() == 'quickcreate') {
          if (field.fieldname.toLowerCase() == 'ownername') continue;
          if (field.fieldname.toLowerCase() == 'ownertype') continue;
        }

        //skip hidden fields
        if (groupFieldAttributes != null) {
          if (groupFieldAttributes.hidden == true) continue;
        }

        var column = 1;

        var fld = {
          id: field.metafieldid,
          fieldname: field.fieldname,
          fieldtype: field.fieldtype,
          labelname: field.labelname,
          standard: field.standard,
          required: field.required,
          readonly: field.readonly,
          slno: '0',
        }

        fld.slno = this.column1GroupFields[field.metagroupname].length + 1 + '_C1'
        this.column1GroupFields[field.metagroupname].push(fld);


        index++;
      }

      //remove selected fields from unselected fields
      for (let grpfld of groupFields) {
        this.fieldList = this.fieldList.filter(eachUnselected => eachUnselected.fieldname != grpfld.fieldname);
      }


    }

  }

  openFieldOption(column: any, groupId: any, groupName: any, field: { [x: string]: any; }): void {

    this.fieldOption['column'] = column
    this.fieldOption['groupid'] = groupId
    this.fieldOption['groupname'] = groupName
    this.fieldOption['fieldid'] = field['id']
    this.fieldOption['fieldname'] = field['fieldname']
    this.fieldOption['required'] = field['required']
    this.fieldOption['readonly'] = field['readonly']

    const dialogRef = this.dialog.open(QuickLayoutFieldOptions, {
      width: '576px',
      data: this.fieldOption,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      //alert('The dialog was closed');
      //alert(JSON.stringify(result))
      console.log('The dialog was closed');
      this.fieldOption = result;
      if (result != undefined) {
        if (this.fieldOption['column'] == 1) {
          this.groupList.forEach((eachGroup, groupIndex, groupArray) => {

            if (eachGroup.groupid == this.fieldOption['groupid']) {

              this.column1GroupFields[eachGroup.groupname].forEach((eachField: { id: any; }, fieldIndex: string | number, array: any) => {
                if (eachField.id == this.fieldOption['fieldid']) {
                  this.column1GroupFields[eachGroup.groupname][fieldIndex]['required'] = this.fieldOption['required']
                  this.column1GroupFields[eachGroup.groupname][fieldIndex]['readonly'] = this.fieldOption['readonly']
                }
              })
            }

          })

        }

      }
      else {
        this.setDefaultOption()
      }

      //alert(JSON.stringify(result))
    });
  }

  createMetaLayoutGroupField(metaLayoutNew: { metaobjectname: string; metaobjectid: any; embeddedobject: any; parentobjectid: any; id: any; active: any; hasrecordtype: string; action: string; }, metaLayoutGroup: { id: any; metaobjectid?: any; embeddedobject?: any; parentobjectid?: any; metalayoutid?: any; name: any; groupsequence: any; showondetailpage?: any; showoneditpage?: any; active?: any; metalayoutgroupfields?: any[]; }) {
    console.log("metalayoutnew:createMetaLayoutGroupField");
    //get metagroupfield details and assign it to postoption

    var arrMergedFields = [];

    //if detail group then add default fields like ownerid, ownername, ownertype
    if (metaLayoutGroup.name == metaLayoutNew.metaobjectname + ' ' + 'Information') {
      var fieldsFilter = this.fields.filter(function (field) {
        return field.fieldname.toLowerCase() == 'ownerid' || field.fieldname.toLowerCase() == 'ownername' ||
          field.fieldname.toLowerCase() == 'ownertype';
      });

      fieldsFilter.sort((a, b) => (a.fieldname.toLowerCase() > b.fieldname.toLowerCase()) ? 1 : -1);

      for (let i = 0; i < fieldsFilter.length; i++) {
        var fld = fieldsFilter[i];
        fld.slno = 0 + '_C_' + i;
        arrMergedFields.push(fld);
      }

    }
    //column1GroupFields
    this.column1GroupFields[metaLayoutGroup.name].forEach((eachField: any, fieldIndex: any, array: any) => {
      arrMergedFields.push(eachField);
    });

    arrMergedFields.sort((a, b) => (a.slno.toLowerCase() > b.slno.toLowerCase()) ? 1 : -1);
    console.log("arrMergedFields", arrMergedFields);

    var arrMetaGroupField = [];

    for (let j = 0; j < arrMergedFields.length; j++) {
      var grpField = arrMergedFields[j];

      var fieldsFilter = this.fields.filter(function (field) {
        return field.id == grpField.id;
      });

      var orgField = fieldsFilter[0];

      var required = false;
      required = grpField.required;
      if (grpField.fieldname.toLowerCase() == 'name') required = true;

      var fieldSequence = (metaLayoutGroup.groupsequence * 1000) + (j + 1);//index j
      var metaGroupField = {
        id: this.guid.getGUID("MetaLayoutGroupField"),
        metaobjectid: metaLayoutNew.metaobjectid,
        embeddedobject: metaLayoutNew.embeddedobject,
        parentobjectid: metaLayoutNew.parentobjectid,
        metalayoutid: metaLayoutNew.id,
        metagroupid: metaLayoutGroup.id,
        metafieldid: grpField.id,
        fieldname: grpField.fieldname,
        fieldtype: grpField.fieldtype,
        labelname: grpField.labelname,
        fieldattributes: orgField.attributes,
        supportingobjectid: '',
        supportingfield: false,
        standard: orgField.standard,
        fieldsequence: fieldSequence,
        defaultvalue: orgField.defaultvalue,
        required: required,
        primary: orgField.primaryfield,
        visible: orgField.visible,
        readonly: grpField.readonly,
        derivedfield: false,
        active: metaLayoutNew.active,
        groupfieldattributes: {},
        createddate: orgField.createddate,
      };

      var metaGroupFieldAttributes = {};
      if (grpField.fieldname.toLowerCase() == 'id') {
        metaGroupFieldAttributes = {
          recordtypeexist: 'false',
          object: '',
          linkfield: '',
          hidden: true,
          linkrelativeurl: '',
          islink: false
        };
      }
      else if (grpField.fieldname.toLowerCase() == 'name') {
        //var linkrelativeurl = 'web/v1/' + this.metaobjectName + '/leadview';
        var linkrelativeurl = 'web/v1/lead/leadview';
        metaGroupFieldAttributes = {
          recordtypeexist: '' + metaLayoutNew.hasrecordtype,
          object: metaLayoutNew.metaobjectname,
          linkfield: 'id',
          hidden: false,
          linkrelativeurl: linkrelativeurl,
          islink: true
        };
      }
      else if (metaLayoutNew.action.toLowerCase().trim() == "new" &&
        (grpField.fieldtype.toLowerCase() == 'id' || grpField.fieldname.toLowerCase() == 'ownertype' || grpField.fieldname.toLowerCase() == 'ownername')) {
        metaGroupFieldAttributes = {
          recordtypeexist: 'false',
          object: '',
          linkfield: '',
          hidden: true,
          linkrelativeurl: '',
          islink: false
        };
      }
      else {
        metaGroupFieldAttributes = {
          recordtypeexist: 'false',
          object: '',
          linkfield: '',
          hidden: false,
          linkrelativeurl: '',
          islink: false
        };
      }

      metaGroupField.groupfieldattributes = metaGroupFieldAttributes;

      console.log("metaGroupField", metaGroupField);

      arrMetaGroupField.push(metaGroupField);
    }

    return arrMetaGroupField;
  }

  save() {

    this.isLoading = false;
    this.isError = false;

    //selected button validation
    if (this.selectedButtons.length == 0) {
      this.showWarning("You must have atleast one button in the page layout");
      return;
    }

    //selected field list validation
    if (this.groupList.length == 0) {
      this.showWarning("You must have atleast one group in the page layout");
      return;
    }

    console.log("this.column1GroupFields[this.metaobjectName + ' ' + 'Information'].length", this.column1GroupFields[this.metaobjectName + ' ' + 'Information'].length);
    //selected field list validation
    if (this.column1GroupFields[this.metaobjectName + ' ' + 'Information'].length > 10) {
      this.showWarning("Quick create can have max. 10 fields only");
      return;
    }

    var hasRecordType = (this.recordTypes.length > 0 ? true : false);

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    //get copy of the current metalayout
    var metaLayoutNew = JSON.parse(JSON.stringify(this.metalayout));
    /*
    var metaLayoutAttributes = {
      "activity": this.metalayout.attributes.activity,
      "notesandattachments": this.metalayout.attributes.notesandattachments,
      "relatedlistflag": this.metalayout.attributes.relatedlistflag,
    };
*/
    metaLayoutNew['hasrecordtype'] = hasRecordType;
    metaLayoutNew['mode'] = this.mode;
    metaLayoutNew['metalayoutbuttonsprovided'] = true;

    //  metaLayoutNew.attributes = metaLayoutAttributes;
    metaLayoutNew.metaprofilelayouts = [];
    metaLayoutNew.metaprofilelayoutcriterias = [];
    metaLayoutNew.metalayoutgroups = [];
    metaLayoutNew.metalayoutgroupfields = [];
    metaLayoutNew.metaprofilelayoutwebs = [];
    metaLayoutNew.metalayoutbuttons = [];

    //metaprofilelayout
    var metaProfileLayoutAttributes = {
      "queueid": '',
      "filterbyowner": '',
    };

    //loop profiles and create layouts with as many profiles
    for (var profile of this.profiles) {

      var metaProfileLayoutId = this.guid.getGUID("MetaProfileLayout");

      var metaProfileLayout = {
        id: metaProfileLayoutId,
        metaobjectid: metaLayoutNew.metaobjectid,
        embeddedobject: metaLayoutNew.embeddedobject,
        parentobjectid: metaLayoutNew.parentobjectid,
        metalayoutid: metaLayoutNew.id,
        recordtypeid: '',
        profileid: profile.id,
        description: '',
        actiontype: metaLayoutNew.action,
        active: metaLayoutNew.active,
        attributes: metaProfileLayoutAttributes,
      };

      //push metaprofilelayout to metaLayoutNew
      metaLayoutNew.metaprofilelayouts.push(metaProfileLayout);
    }

    //****** metalayoutgroup  *********/
    for (let i = 0; i < this.groupList.length; i++) {
      var group = this.groupList[i];

      var metaLayoutGroup = {
        id: group.groupid,
        metaobjectid: metaLayoutNew.metaobjectid,
        embeddedobject: metaLayoutNew.embeddedobject,
        parentobjectid: metaLayoutNew.parentobjectid,
        metalayoutid: metaLayoutNew.id,
        name: group.groupname,
        groupsequence: i + 1,
        showondetailpage: group.showondetailpage,
        showoneditpage: group.showoneditpage,
        active: metaLayoutNew.active,
        metalayoutgroupfields: [],
      };

      //****** metalayoutgroupfield *********/

      //create metalayoutgroupfield and assign it to metalayoutgroup
      var arrMetaGroupField = this.createMetaLayoutGroupField(metaLayoutNew, metaLayoutGroup);
      //inputJSONForLayout.metalayout.metalayoutgroupfields = arrMetaGroupField;
      metaLayoutGroup.metalayoutgroupfields = arrMetaGroupField;

      //push metalayoutgroup to metaLayoutNew
      metaLayoutNew.metalayoutgroups.push(metaLayoutGroup);


    }

    //****** metaprofilelayout  *********/

    //metaprofilelayoutwebarray

    //loop profiles and create layouts with as many profiles
    for (var profile of this.profiles) {
      var metaProfileLayoutWebId = this.guid.getGUID("MetaProfileLayoutWeb");

      var metaProfileLayoutWeb = {
        id: metaProfileLayoutWebId,
        metaobjectid: metaLayoutNew.metaobjectid,
        metaobjectname: metaLayoutNew.metaobjectname,
        embeddedobject: metaLayoutNew.embeddedobject,
        parentobjectid: metaLayoutNew.parentobjectid,
        metalayoutid: metaLayoutNew.id,
        metalayoutname: metaLayoutNew.name,
        recordtypeid: null,
        recordtypename: '',
        profileid: profile.id,
        profilename: profile.name,
        userid: null,
        username: '',
        description: '',
        actiontype: metaLayoutNew.action,
        active: metaLayoutNew.active,
        layoutjsontext: {},
        fieldjsontext: {},
        criteriajsontext: {},
      };

      //push metaprofilelayout to metaLayoutNew
      metaLayoutNew.metaprofilelayoutwebs.push(metaProfileLayoutWeb);

    }

    //****** metalayoutbuttons  *********/

    //metalayoutbuttonsarray

    //loop selected buttons and create buttonlayouts with as many profiles
    for (let i = 0; i < this.selectedButtons.length; i++) {
      var button = this.selectedButtons[i];

      var metaButtonAttributes: any;
      if (hasRecordType == true) {
        var buttonAttributes = JSON.parse(JSON.stringify(button.attributes));
        buttonAttributes.recordtypeexists = true;
        metaButtonAttributes = buttonAttributes;
      }
      else {
        metaButtonAttributes = JSON.parse(JSON.stringify(button.attributes));
      }

      var metaLayoutButtonId = this.guid.getGUID("MetaLayoutButton");

      var metaLayoutButton = {
        id: metaLayoutButtonId,
        metaobjectid: metaLayoutNew.metaobjectid,
        embeddedobject: metaLayoutNew.embeddedobject,
        parentobjectid: metaLayoutNew.parentobjectid,
        metalayoutid: metaLayoutNew.id,
        metalayoutname: metaLayoutNew.name,
        labelname: button.labelname,
        name: button.name,
        description: button.description,
        buttontype: button.buttontype,
        actiontype: button.actiontype,
        buttonsequence: i + 1,
        active: button.active,
        attributes: metaButtonAttributes,
      }

      //push metalayoutbutton to metaLayoutNew
      metaLayoutNew.metalayoutbuttons.push(metaLayoutButton);

    }

    //prepare data for saving: metadata
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
      subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profileid: userDetail.profileid,
      profilename: userDetail.profilename,
      data: {
        metalayout: metaLayoutNew
      }
    }

    console.log("postOption", postOption);

    this.isLoading = true;
    this.dataService.upsertMetalayout(postOption).subscribe(
      res => {
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl('/home/metaobjectdetail/' + this.metaobjectId + '/' + this.metaobjectName);
        }
        else {
          console.log("error");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      err => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );

  }

}

@Component({
  selector: 'layout-field-option-modal',
  templateUrl: 'quicklayoutfieldoptions.html',
})
export class QuickLayoutFieldOptions implements OnInit {
  ngOnInit() {
    this.setModalUI()
  }

  constructor(
    public dialogRef: MatDialogRef<QuickLayoutFieldOptions>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any, private formbuilder: FormBuilder) { }

  form: FormGroup;
  setModalUI() {
    const formGroup = {};

    this.form = this.formbuilder.group({
      isRequired: [false],
      isReadOnly: [false]
    })

    // this.dialogData['required']
    // this.dialogData['readonly']

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
